import { useState, useRef, lazy, Suspense } from "react";

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
const Chip = lazy(() => import('@mui/material/Chip'));
import Reset from '@/pages/Password/Reset';
import RootTools from '@/components/Root/Tools';

import { styleCards } from '@/utils/Styles';

import { Collapse } from '@mui/material';
import Button from '@/components/Button';

import { 
    Close as ResetIcon
} from '@mui/icons-material';

export default function Profile({ t, language, user, setUser, router, apiUrl, token, sendMessage, handleLogin, fullScreen, openUrlModal }){

    const containerRef = useRef(null);
    const [ showResetPassword, setShowResetPassword ] = useState(false);

    const { sxCard } = styleCards();

    const handleResetPassword = () => {
        setShowResetPassword(!showResetPassword);
    }

    return (
        <>
        <Card sx={sxCard}>           
            <CardContent>                    
                <div className="text-xl font-bold">
                    {user?.name}
                </div>
                <div className="">
                    {user?.email}
                </div>
                <div className="">
                    {user?.companies[user?.company]?.name}
                </div>
                <div className="mt-4">
                    {
                        user?.roles && user.roles.map((role) => (
                            <Chip key={role?.id} label={role?.name} className="m-1"/>
                        ))
                    }
                </div>
            </CardContent>             
        </Card>
        <div className='mt-4' ref={containerRef}>
            <div className='flex justify-center mb-2'>
                <Button
                    onClick={handleResetPassword}
                    text={showResetPassword ? t('actions.hide.button') : t('reset.button-profile')}
                    type={showResetPassword ? 'back' : 'reset'}
                    variant='contained'
                    startIcon={<ResetIcon/>}
                />                        
            </div>
            <Collapse 
                in={showResetPassword}
                timeout={500}                    
                container={containerRef.current}
            >        
                <Reset
                    t={t}
                    language={language}
                    router={router}
                    user={user}
                    setUser={setUser}
                    token={token}
                    apiUrl={apiUrl}                    
                    sendMessage={sendMessage} 
                    handleLogin={handleLogin}
                    embedded={true}
                    fullScreen={fullScreen}
                />        
            </Collapse>
        </div>
        <RootTools
            t={t}
            user={user}
            apiUrl={apiUrl}
            token={token}
            language={language}
            sendMessage={sendMessage} 
            handleLogin={handleLogin}
            openUrlModal={openUrlModal}
        />
        </>
    );
}
